export default __webpack_public_path__ + "static/media/qr.1abff40b.png";